import IntLink from 'components/common/IntLink'
import { FC } from 'react'

type Props = {
  name: string
  /** SEO-заголовок страницы; по умолчанию = name (config/seoH1.ts) */
  h1?: string
  isMain?: boolean
}

const CategoryDescription: FC<Props> = ({ name, h1, isMain = false }) => {
  return (
    <div className='hidden lg:block py-8 pr-0 custom-plx'>
      <div className='w-full'>
        <div className='hidden lg:block text-sm2 leading-tight tracking-tight'>
          <IntLink
            className='text-dark underline hover:text-accent'
            href='/'
          >
            Главная
          </IntLink>

          {!isMain && (
            <>
              {' — '}
              <IntLink
                className='text-dark underline hover:text-accent'
                href='/categories'
              >
                Меню
              </IntLink>
            </>
          )}
          <span className='text-greyA1'>{` — ${name}`}</span>
        </div>

        <h1
          itemProp='name'
          className='pt-4 font-unbounded font-medium text-2xl lg:text-5xl lg:leading-tight tracking-tight '
        >
          {h1 ?? name}
        </h1>
      </div>
    </div>
  )
}

export default CategoryDescription
